import { AppState, Auth0Provider } from '@auth0/auth0-react';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import config from './config';

const Auth0ProviderWithNavigate = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();

  const domain = config.AUTH0_DOMAIN;
  const clientId = config.AUTH0_CLIENT_ID;
  const audience = config.AUTH0_CONSOMMATEUR_AUDIENCE;

  const onRedirectCallback = (appState?: AppState | undefined) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  if (!(domain && clientId)) {
    return <></>;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        prompt:
          window !== window.parent ||
          location.pathname.toLocaleLowerCase() == '/en/register' ||
          location.pathname.toLocaleLowerCase() == '/fr/inscription'
            ? 'none'
            : 'login',
        redirect_uri: window.location.origin,
        audience: audience,
      }}
      onRedirectCallback={onRedirectCallback}>
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithNavigate;
